import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface IbercajaGenerateRequest {
  appraisalIds: string;
  email: string;
  includeCertificates: boolean;
  ignoreValidation: boolean;
  format: number;
}

@Injectable({
  providedIn: 'root'
})
export class IbercajaService {
  private readonly API_URL = this.buildApiUrl();

  constructor(private http: HttpClient) {}

  private buildApiUrl(): string {
    const baseUrl = environment.apiUrl;

    return `${this.getHangfireUrl()}/api/Ibercaja/GenerateAC/TF/Tasaciones`;
  }

  private getHangfireUrl(): string {
    const baseUrl = environment.apiUrl;

    if (baseUrl.includes('dev')) {
      return 'https://dev-hangfire.iv.solutions';
    } else if (baseUrl.includes('qa')) {
      return 'https://qa-hangfire.iv.solutions';
    } else if (baseUrl.includes('api.iv.solutions')) {
      return 'https://hangfire.iv.solutions';
    }

    return 'https://qa-hangfire.iv.solutions';
  }

  generateTasaciones(request: IbercajaGenerateRequest): Observable<any> {
    return this.http.post(this.API_URL, request);
  }
}
